import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {addEditCategory, delCategory, getCategories} from '../../services';
import {ICategory, ICategoryFilter, ICategoryRes, ICategoryState} from "../types/ICategory";
import historyHelper from "../../helpers/history";
import {AppState} from "./rootReducer";

const initialState: ICategoryState = {
    status: "idle"
}

export const mostrarCategories = createAsyncThunk(
    'mostrarCategories', async (params:ICategoryFilter|undefined, thunkAPI ) => {
        const {categories} = thunkAPI.getState() as AppState;
        let paramsFilter = params || categories.filtered;

        const response = await getCategories(paramsFilter)
        return {data: response.data as ICategoryRes, params: response.config.params}
    }
)

export const mostrarCategoriesSinoEsta = createAsyncThunk(
    'mostrarCategoriesSinoEsta', async (_,thunkAPI) => {
        let categories = (thunkAPI.getState() as AppState)?.categories;
        if (!!categories?.list?.items.length || categories.status === "loading") return false;

        return thunkAPI.dispatch(mostrarCategories());

    }
)


export const agregarEditarCategory = createAsyncThunk(
    'Categories/agregarEditar', async (category: ICategory) => {
        const response = await addEditCategory(category);
        if (response.status === 200 || response.status === 204) historyHelper.back();
        return {data: response.data, edit:!!category.id};
    }
);

export const eliminarCategory = createAsyncThunk(
    'category/eliminar', async (id: number) => {
         await delCategory(id);
        // if (response.status === 200 || response.status === 204) historyHelper.back();
        return id;
    }
);


const slice = createSlice({
    name: 'mostrarCategories',
    initialState,
    reducers: {
    },
    extraReducers: builder => {
        //--mostrarCategories
        builder.addCase(mostrarCategories.pending, (state ) => {
            state.status = "loading";
        })
        builder.addCase(mostrarCategories.fulfilled, (state,action ) => {
            state.status = "idle";
            state.filtered = action.payload.params;
            state.list = action.payload.data;
        })
        builder.addCase(mostrarCategories.rejected, (state ) => {
            state.status = "idle";
        })

        //--agregarEditarCategory
        builder.addCase(agregarEditarCategory.pending, (state ) => {
            state.status = "loading";
        })
        builder.addCase(agregarEditarCategory.fulfilled, (state,action ) => {
            state.status = "idle";
            if(state.list){
                state.list.items = state.list?.items.filter(e => e.id !== action.payload.data.id);
                state.list.items.unshift(action.payload.data);
                if(!action.payload.edit){
                    ++state.list.pageSize
                    ++state.list.totalCount
                }

            }
        })
        builder.addCase(agregarEditarCategory.rejected, (state ) => {
            state.status = "idle";
        })
        //--eliminarCategory
        builder.addCase(eliminarCategory.pending, (state ) => {
            state.status = "loading";
        })
        builder.addCase(eliminarCategory.fulfilled, (state,action ) => {
            state.status = "idle";
            const id = action.payload;
            if(state.list?.items){
                state.list.items = state.list?.items.filter(e => e.id !== id)
            }
        })
        builder.addCase(eliminarCategory.rejected, (state ) => {
            state.status = "idle";
        })
    }
});

export default slice.reducer;
